import source from '@/api/modules/source'
import song from '@/api/modules/song'
export default {
  source,
  song
}
